import { render, staticRenderFns } from "./ManageAttachments.vue?vue&type=template&id=1aefecd7"
import script from "./ManageAttachments.vue?vue&type=script&lang=js"
export * from "./ManageAttachments.vue?vue&type=script&lang=js"
import style0 from "./ManageAttachments.vue?vue&type=style&index=0&id=1aefecd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports